const WishlistIcon = (props: { color: string }) => {
	return (
		<svg
			width='22'
			height='19'
			viewBox='0 0 22 19'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12.9896 16.8644C11.7888 17.6948 10.2112 17.6948 9.01043 16.8645C5.55458 14.4748 1.0719 10.4874 1.00113 6.50735C0.91875 1.87846 5.37418 -0.523129 9.39795 2.05453C10.356 2.66825 11.644 2.66825 12.6021 2.05454C16.6253 -0.522755 21.0805 1.87762 20.9989 6.50643C20.9288 10.4868 16.4457 14.4746 12.9896 16.8644Z'
				fill={props.color}
				stroke='#BCBCBC'
				stroke-width='1.5'
			/>
		</svg>
	);
};

export default WishlistIcon;
